import { useState, useMemo, useEffect } from 'react';
import { always, ifElse, is, prop, propEq, propOr, trim } from 'ramda';
import { decodeJwtSafely } from '../utils/jwt';

const normalizeEmail = ifElse(is(String), trim, always(''));

const getEmailFromToken = (token) => {
  const payload = decodeJwtSafely(token);
  const email = propOr('', 'email', payload);
  return normalizeEmail(email);
};

const useSignUpToken = (location) => {
  const search = propOr('', 'search', location);
  const token = useMemo(() => new URLSearchParams(search).get('token'), [search]);
  const email = getEmailFromToken(token);
  const [isValidToken, setIsValidToken] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const verifyToken = async () => {
      try {
        const response = await fetch(`/user/verify-token?token=${token}`, {
          headers: { Authorization: `Bearer ${token}` },
          signal: prop('signal', controller)
        });
        setIsValidToken(propEq(200, 'status', response));
      } catch (error) {
        if (error.name !== 'AbortError') {
          setIsValidToken(false);
        }
      }
    };
    if (token) {
      verifyToken();
    } else {
      setIsValidToken(false);
    }
    return () => controller.abort();
  }, [token]);

  return {
    isValidToken,
    email,
    token
  };
};

export default useSignUpToken;